<template>
  <div class="step-informacoes">
    <div class="form-group">
      <label class="field-label">Nome</label>
      <input
        class="form-control form-control-sm"
        maxlength="1000"
        v-model="item.nome"
        placeholder="Nome do banner"
      />
      <div v-if="validacao.firstError('item.nome')" class="message">
        {{ validacao.firstError("item.nome") }}
      </div>
    </div>

    <div class="step-informacoes__section">
      <div class="section-label">Local de exibição</div>
      <div class="step-informacoes__locais-grid">
        <SelectableCard
          v-for="local in locais"
          :key="local.key"
          :value="local.key"
          :label="local.label"
          :description="local.description"
          :icon="local.icon"
          :selected="item.local === local.key"
          @select="selecionarLocal"
        />
      </div>
    </div>

    <CRow>
      <CCol md="4">
        <div class="form-group">
          <label class="field-label">Data inicial de exibição</label>
          <datetime
            input-class="form-control form-control-sm"
            type="date"
            v-model="item.data_inicio"
            :max-datetime="item.data_fim"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            format="d/M/y"
          />
        </div>
      </CCol>
      <CCol md="4">
        <div class="form-group">
          <label class="field-label">Data final de exibição</label>
          <datetime
            input-class="form-control form-control-sm"
            type="date"
            :min-datetime="item.data_inicio"
            v-model="item.data_fim"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            format="d/M/y"
          />
        </div>
      </CCol>
      <CCol md="4" v-if="campoVisivel(item.local, 'ordem')">
        <div class="form-group">
          <label class="field-label">Ordem de exibição</label>
          <input
            class="form-control form-control-sm"
            v-model="item.ordem"
            maxlength="2"
          />
        </div>
      </CCol>
    </CRow>

    <p class="step-informacoes__hint">
      Sem data inicial ou final, o banner é considerado sempre vigente.
    </p>
  </div>
</template>

<script>
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import { LOCAIS, campoVisivel } from "../helpers/bannerLabels";
import { limparCamposNaoUsados } from "../helpers/bannerDefaults";

export default {
  name: "StepInformacoes",
  components: { SelectableCard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      locais: LOCAIS,
    };
  },
  methods: {
    campoVisivel,
    selecionarLocal(local) {
      if (this.item.local === local) {
        return;
      }

      this.$set(this.item, "local", local);
      limparCamposNaoUsados(this.item);
    },
  },
};
</script>

<style scoped>
.step-informacoes .form-group {
  margin-bottom: 10px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-informacoes__section {
  margin-top: 12px;
  margin-bottom: 12px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-informacoes__locais-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.step-informacoes__hint {
  font-size: 11px;
  color: #98a2b3;
  margin: 0;
}

@media (max-width: 768px) {
  .step-informacoes__locais-grid {
    grid-template-columns: 1fr;
  }
}
</style>
